import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { cekCookies } from "../../../../../actions";
import akmApi from "../../../../../apis/akmApi";
import Navbar from "../../../navbar/Navbar";
import Sidebar from "../../../sidebar/Sidebar";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Alert from "@material-ui/lab/Alert";
import { canSupplyStock, newStockRequestId, validStockInput } from "./stockAccess";
import "./stokVoucher.css";

const STORAGE = "eduprime.pendingStockBatch";
const TYPES = ["EVENT", "PSEP", "PREMIUM"];
const empty = { tersedia: {}, riwayat: [] };

export class StokVoucher extends React.Component {
  state = { jenis: "EVENT", jumlah: "", keterangan: "", data: empty, ready: false, checking: true, busy: false, denied: false,
    review: false, pending: null, result: null, message: "", severity: "info" };
  inFlight = false;
  alive = false;
  async componentDidMount() {
    this.alive = true;
    await this.props.cekCookies();
    if (!this.alive) return;
    if (!canSupplyStock(this.props.account)) { this.setState({ checking: false, denied: true }); return; }
    this.setState({ checking: false });
    try {
      const pending = JSON.parse(sessionStorage.getItem(STORAGE));
      if (pending && pending.actor === this.actorKey() && pending.requestId) {
        this.setState({ pending, jenis: pending.jenis, jumlah: String(pending.jumlah), keterangan: pending.keterangan,
          message: "Ada penambahan yang perlu diperiksa. Periksa hasil sebelum membuat batch baru." });
      }
    } catch (error) { /* Tidak mengulang POST ketika penyimpanan lokal tidak tersedia. */ }
    await this.refresh();
  }
  componentWillUnmount() { this.alive = false; }
  actorKey = () => String(this.props.account.idAdmin || this.props.account.idUser || this.props.account.idProfile || this.props.account.user_name || this.props.account.username || this.props.account.namaUser || this.props.account.idRole);
  showError = error => {
    if (!this.alive) return;
    const status = error && error.response && error.response.status;
    this.setState({ denied: status === 403, message: status === 403 ? "Akun ini tidak berhak mengelola stok voucher." :
      (error && error.response && error.response.data && error.response.data.message) || "Layanan belum dapat dihubungi. Coba periksa kembali.", severity: "error" });
  };
  refresh = async () => {
    try {
      const response = await akmApi.get("/voucher/stok", { timeout: 10000 });
      if (!response.data || !response.data.tersedia || !Array.isArray(response.data.riwayat)) throw new Error("Respons tidak lengkap");
      if (this.alive) this.setState({ data: response.data, ready: true });
    } catch (error) { this.showError(error); }
  };
  review = event => {
    event.preventDefault();
    if (this.inFlight || this.state.pending || !this.state.ready) return;
    if (!validStockInput(this.state.jumlah, this.state.keterangan)) {
      this.setState({ message: "Isi jumlah bulat 1–10.000 dan keterangan batch 1–250 karakter.", severity: "error" }); return;
    }
    this.setState({ review: true, message: "" });
  };
  complete = async receipt => {
    const pending = this.state.pending;
    if (!receipt || !pending || receipt.requestId !== pending.requestId || receipt.jumlah !== pending.jumlah || receipt.jenis !== pending.jenis) throw new Error("Receipt tidak cocok");
    try { sessionStorage.removeItem(STORAGE); } catch (error) { /* Receipt server tetap sumber kebenaran. */ }
    if (!this.alive) return;
    this.setState({ result: receipt, pending: null, jumlah: "", keterangan: "", message: receipt.jumlah + " voucher " + receipt.jenis + " berhasil ditambahkan.", severity: "success" });
    await this.refresh();
  };
  save = async () => {
    if (this.inFlight || this.state.pending || !this.state.review) return;
    let request;
    try {
      request = { requestId: newStockRequestId(), jenis: this.state.jenis, jumlah: Number(this.state.jumlah), keterangan: this.state.keterangan.trim(), actor: this.actorKey() };
      // Simpan sebelum dispatch sehingga refresh tetap dapat memeriksa receipt yang sama.
      sessionStorage.setItem(STORAGE, JSON.stringify(request));
    } catch (error) {
      this.setState({ review: false, message: "Penyimpanan sesi atau pembuat ID aman tidak tersedia. Aktifkan sebelum menyimpan stok.", severity: "error" }); return;
    }
    this.inFlight = true;
    this.setState({ pending: request, review: false, busy: true }, () => this.postPending(request));
  };
  postPending = async request => {
    try {
      const { actor, ...body } = request;
      const response = await akmApi.post("/voucher/stok", body, { timeout: 35000 });
      await this.complete(response.data);
    } catch (error) {
      const status = error && error.response && error.response.status;
      if (status === 400 || status === 403) {
        // Kedua status ini berasal dari penolakan sebelum penambahan; isian boleh diperbaiki.
        try { sessionStorage.removeItem(STORAGE); } catch (storageError) { /* Server tidak menambah stok. */ }
        if (this.alive) { this.setState({ pending: null }); this.showError(error); }
      } else if (this.alive) {
        this.showError(error);
        this.setState({ message: "Hasil penambahan belum terkonfirmasi. Gunakan Periksa hasil; bila perlu, ulangi permintaan yang sama. Stok tidak ditambahkan dua kali.", severity: "warning" });
      }
    } finally {
      this.inFlight = false;
      if (this.alive) this.setState({ busy: false });
    }
  };
  check = async () => {
    if (this.inFlight || !this.state.pending) return;
    this.inFlight = true; this.setState({ busy: true });
    try {
      const response = await akmApi.get("/voucher/stok/permintaan/" + this.state.pending.requestId, { timeout: 10000 });
      await this.complete(response.data);
    } catch (error) { this.showError(error); }
    finally { this.inFlight = false; if (this.alive) this.setState({ busy: false }); }
  };
  retry = () => {
    if (this.inFlight || !this.state.pending) return;
    this.inFlight = true; this.setState({ busy: true }); this.postPending(this.state.pending);
  };
  render() {
    const s = this.state;
    const allowed = canSupplyStock(this.props.account) && !s.denied;
    const locked = s.busy || !!s.pending || !s.ready;
    return <div className="wrapper">
      <Sidebar account={this.props.account} />
      <main id="content" className="stock-voucher">
        <Navbar title="Stok Voucher" />
        {s.checking ? <Alert severity="info">Memeriksa akses stok voucher...</Alert> : !allowed ? <Alert severity="error">Akun ini tidak berhak mengelola stok voucher.</Alert> : <>
          <div className="stock-heading"><div><Typography variant="h5" component="h1">Supply Stok Voucher</Typography>
            <Typography color="textSecondary">Tambahkan voucher baru ke stok yang siap dijual.</Typography></div>
            <Button component={Link} to="/penjualanvoucher" variant="outlined" color="primary">Penjualan Voucher</Button></div>
          {s.message && <Alert severity={s.severity} role="status" className="stock-message">{s.message}</Alert>}
          <Grid container spacing={2} className="stock-counts">{TYPES.map(type => <Grid item xs={12} sm={4} key={type}>
            <Paper className="stock-card"><Typography color="textSecondary">{type} tersedia</Typography><Typography variant="h4">{s.ready ? s.data.tersedia[type] : "—"}</Typography></Paper>
          </Grid>)}</Grid>
          <Paper className="stock-card"><Typography variant="h6" component="h2">Tambah stok</Typography>
            <Typography color="textSecondary" className="stock-help">Stok tersedia dihitung per jenis. Durasi dan harga belum ditentukan saat penambahan stok. Paket, durasi dan harga ditentukan pada alur penjualan yang sesuai. Maksimal 10.000 voucher per batch.</Typography>
            <form onSubmit={this.review}><Grid container spacing={3}>
              <Grid item xs={12} sm={6}><TextField id="jenis-stok" select fullWidth label="Jenis voucher" value={s.jenis} disabled={locked} onChange={event => this.setState({ jenis: event.target.value })}>{TYPES.map(type => <MenuItem key={type} value={type}>{type}</MenuItem>)}</TextField></Grid>
              <Grid item xs={12} sm={6}><TextField fullWidth required id="jumlah-stok" label="Jumlah penambahan" value={s.jumlah} disabled={locked} onChange={event => this.setState({ jumlah: event.target.value })} inputProps={{ inputMode: "numeric", pattern: "[1-9][0-9]{0,4}", maxLength: 5 }} helperText="Bilangan bulat 1–10.000" /></Grid>
              <Grid item xs={12}><TextField id="keterangan-stok" fullWidth required label="Keterangan / nama batch" value={s.keterangan} disabled={locked} onChange={event => this.setState({ keterangan: event.target.value })} inputProps={{ maxLength: 250 }} helperText="Contoh: Persediaan Oktober 2026" /></Grid>
            </Grid><div className="stock-actions"><Button type="submit" variant="contained" color="primary" disabled={locked}>Tinjau penambahan</Button><Button onClick={this.refresh} disabled={s.busy}>Muat ulang stok</Button></div></form>
          </Paper>
          {s.pending && <Paper className="stock-card"><Typography variant="h6">Periksa penambahan</Typography><Typography>{s.pending.jumlah} voucher {s.pending.jenis} · {s.pending.keterangan}</Typography><Typography className="stock-id">ID permintaan: {s.pending.requestId}</Typography><div className="stock-actions"><Button onClick={this.check} disabled={s.busy} variant="contained" color="primary">Periksa hasil</Button><Button onClick={this.retry} disabled={s.busy} variant="outlined">Ulangi permintaan yang sama</Button></div></Paper>}
          <Paper className="stock-card"><Typography variant="h6" component="h2">Riwayat penambahan</Typography><Typography color="textSecondary">50 batch terbaru. Aktor ditampilkan sebagai ID akun internal.</Typography>
            {s.ready && !s.data.riwayat.length && <Typography className="stock-help">Belum ada penambahan stok yang tercatat.</Typography>}
            <ul className="stock-history">{s.data.riwayat.map(row => <li key={row.requestId}><div className="stock-history-title"><strong>{row.jumlah} voucher {row.jenis}</strong><time>{new Date(row.waktu).toLocaleString("id-ID", { timeZone: "Asia/Jakarta" })} WIB</time></div><div>{row.keterangan}</div><small>Aktor #{row.aktorId} · Tersedia saat penambahan: {row.tersediaSebelum} → {row.tersediaSesudah}</small><div className="stock-id">{row.requestId}</div></li>)}</ul>
          </Paper>
          <Dialog open={s.review} onClose={() => !s.busy && this.setState({ review: false })} fullWidth maxWidth="sm" aria-labelledby="stock-review-title"><DialogTitle id="stock-review-title">Tinjau penambahan stok</DialogTitle><DialogContent><Typography><strong>{s.jumlah} voucher {s.jenis}</strong> akan ditambahkan.</Typography><Typography>Keterangan: {s.keterangan.trim()}</Typography><Typography className="stock-help">Tersedia sekarang: {s.data.tersedia[s.jenis]}. Jumlah dapat berubah bila ada penjualan lain.</Typography></DialogContent><DialogActions><Button onClick={() => this.setState({ review: false })}>Kembali</Button><Button onClick={this.save} variant="contained" color="primary" disabled={s.busy}>Simpan stok</Button></DialogActions></Dialog>
        </>}
      </main>
    </div>;
  }
}
export default connect(state => ({ account: state.account }), { cekCookies })(StokVoucher);
